import React from "react";
import * as PropTypes from "prop-types";
import { databasePropType, dataPropType } from "../../propTypes";
import { withStyles } from "@material-ui/styles";
import classNames from "classnames";
import CloseIcon from "@material-ui/icons/Close";
import Annex from "../themes/annex/Annex";
import AnnexNav from "../themes/annex/AnnexNav";
import AreaChooser from "../choosers/AreaChooser";
import { toolbarHeight as mainToolbarHeight } from "../../styleConstants";
import styleConstants from "../../styleConstants";

const styles = {
  appBar: {
    position: "fixed",
    width: "100%",
    top: mainToolbarHeight,
    backgroundColor: "white",
    zIndex: 1
  },
  chooserContainer: {},
  close: {
    cursor: "pointer"
  },
  container: {
    marginTop: mainToolbarHeight,
    marginBottom: "2rem"
  },
  contentContainer: {
    display: "flex"
  },
  content: {
    margin: "2rem 1rem 0"
  },
  annexMenu: {
    marginTop: "3rem"
  },
  toolbar: {
    width: "100%",
    margin: "2rem 0 2rem 1rem",
    paddingRight: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  drawerTitle: {
    color: styleConstants.colors.themeBlue
  },
  annexLinks: {
    display: "flex",
    justifyContent: "center"
  },
  annexMenuInnerContainer: {
    position: "fixed",
    marginLeft: "4rem"
  }
};

const AnnexWidget = props => (
  <div className={classNames("AnnexWidget", props.classes.container)}>
    <div className={props.classes.appBar}>
      <div className={props.classes.toolbar}>
        <h2 className={props.classes.drawerTitle}>Data Annex</h2>
        <CloseIcon className={props.classes.close} onClick={props.onClose} />
      </div>
    </div>

    <div className={props.classes.contentContainer}>
      <div className={props.classes.content}>
        <Annex
          data={props.data}
          onDownloadCsv={id => {
            props.onDownloadCsv(id, {
              area: props.database.areas[props.areaId].area
            });
          }}
        />
      </div>

      <div className={props.classes.annexMenu}>
        <div className={props.classes.annexMenuInnerContainer}>
          <div
            className={props.classes.chooserContainer}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <AreaChooser
              id="annex"
              label="Select Country or Country Group"
              areas={props.database.areas}
              includeCountries={true}
              selectedKey={props.areaId}
              onChange={props.onAreaChange}
            />
          </div>

          <div className={props.classes.annexLinks}>
            <AnnexNav />
          </div>
        </div>
      </div>
    </div>
  </div>
);

AnnexWidget.propTypes = {
  areaId: PropTypes.number.isRequired,
  database: databasePropType,
  data: dataPropType,
  onAreaChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default withStyles(styles)(AnnexWidget);
